import { createContext, useCallback, useContext, useState } from "react";
import axios from "../api/axios";
import { APIS } from "../api";
import { toast } from "react-toastify";
import { handleNavigationError } from "../api/error";
import { useNavigate } from "react-router-dom";
import { componentRoutes } from "../constants/componentRoutes";

export const FaqContext = createContext({
    faq: [],
    faqLoader: false,
    onLoadFaq: async () => {},
    onAddFaq: async (values) => {},
    onUpdateFaq: async (values) => {},
    onDeleteFaq: async (values) => {}
});

export const FaqProvider = ({ children }) => {

    const [faq, setFaq] = useState(null);
    const [faqLoader, setFaqLoader] = useState(false);
    
    const navigate = useNavigate();

    const onLoadFaq = useCallback(
        async () => {
            setFaqLoader(true);
            try {
                const { data } = await axios.post(APIS.LIST_FAQ);
                if (data.code == 1) {
                    setFaq(data?.data);
                } else {
                    setFaq([]);
                }
                setFaqLoader(false);
            } catch (error) {
                handleNavigationError(navigate, error);
            } finally {
                setFaqLoader(false);
            }
        }, 
        [navigate]
    );

    const onAddFaq = useCallback(
        async (values) => {
            setFaqLoader(true)
            try {
                const { data } = await axios.post(APIS.ADD_FAQ, values);
                if (data.code == 1) {
                    toast.success(data.message);
                } else {
                    toast.error(data.message);
                }
                setFaqLoader(false)
                await onLoadFaq();
                navigate(componentRoutes.faq);
            } catch (error) {
                handleNavigationError(navigate, error);
            } finally {
                setFaqLoader(false)
            }
        }, 
        [onLoadFaq, navigate]
    );

    const onUpdateFaq = useCallback(
        async (values) => {
        setFaqLoader(true)
        try {
                setFaqLoader(false);
                const { data } = await axios.post(APIS.UPDATE_FAQ, values);
            if (data.code == 1) {
                // navigate(componentRoutes.blog);
                toast.success(data.message)
            } else {
                toast.error(data.message);
            }
            setFaqLoader(false)
            await onLoadFaq();
        } catch (error) {
            handleNavigationError(navigate, error);
        } finally {
            setFaqLoader(false)
        }
        }, 
        [onLoadFaq, navigate]
    );

    const onDeleteFaq = useCallback(
        async (values) => {
            setFaqLoader(true)
            const payload = {
                faq_id: values
            }
        try {
            const { data } = await axios.post(APIS.DELETE_FAQ, payload);
            
            if (data.code == 1) {
                toast.success(data.message);
            }
            setFaqLoader(false);
            await onLoadFaq();
            return data;
        } catch (error) {
            handleNavigationError(navigate, error);
        } finally {
            setFaqLoader(false)
        }
    }, [onLoadFaq, navigate]);

    const values = {
        faq,
        faqLoader,
        onLoadFaq: useCallback(
            async() => {
                return await onLoadFaq();
            },
            [onLoadFaq]
        ),
        onAddFaq: useCallback(
            async (values) => {
                return await onAddFaq(values);
            },
            [onAddFaq]
        ),
        onUpdateFaq: useCallback(
            async (values) => {
                return await onUpdateFaq(values);
            },
            [onUpdateFaq]
        ),
        onDeleteFaq: useCallback(
            async (values) => {
                return await onDeleteFaq(values);
            },
            [onDeleteFaq]
        ),
    };



    return (
        <FaqContext.Provider value={values}>
            {children}
        </FaqContext.Provider>
    );
};

export const useFaq = () => useContext(FaqContext);